// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ACTION_TO_SET_FAVORITE_TOPIC = "p\u0159id\u00e1n\u00ed kategorie do obl\u00edben\u00fdch";
export const ACTION_TO_SUBSCRIBE_TOPIC = "odeb\u00edr\u00e1n\u00ed kategorie";
export const ARE_YOU_SURE_YOU_WANT_TO_DELETE_TOPIC = "Opravdu chce\u0161 kategorii smazat?";
export const EXPLAIN_TOPIC_DELETION = "Zadej podrobn\u00e9 zd\u016fvodn\u011bn\u00ed:";
export const FORUM_TOPIC_ALREADY_SUBSCRIBED_TOAST_name = "Odeb\u00edr\u00e1\u0161 %(name)s.";
export const FORUM_TOPIC_SUBSCRIBED_TOAST_name = "Za\u010dala jsi odeb\u00edrat %(name)s.";
export const FORUM_TOPIC_topic_IS_ADDED_TO_FAVORITES = "P\u0159idala sis kategorii %(topic)s do obl\u00edben\u00fdch.";
export const FORUM_TOPIC_topic_IS_REMOVED_FROM_FAVORITES = "Odstranila sis kategorii %(topic)s z obl\u00edben\u00fdch.";
export const FORUM_TOPIC_UNSUBSCRIBED_TOAST_name = "U\u017e neodeb\u00edr\u00e1\u0161 %(name)s.";
